module.exports = __webpack_public_path__ + "img/tuceng74.bb1a5cbf.png";